import alertModalTmpl from './_alertModal.hbs';
import modalTmpl from './_modal.hbs';
import modalConfirmTmpl from './_modalConfirm.hbs';

const MODAL_ID = 'isaModal';
const BUTTON_ID = '#btnModalAction';
const ERRORTYPE = {
    ERROR: 'error',
    WARN: 'warn'
};

export const MODAL_CONFIRM_ID = 'isaModalConfirm';
/**********************************************************
    modalData: {
        title: 'Title',
        content: '<p>Content of the alert</p>',
        buttonText: 'OK'
    }
**********************************************************/
// legacy
export function showAlert(modalData, buttonFunction, option) {
    if($('#alertModal').length <= 0) { return; }

    // if there is no data, don't do anything
    if(!modalData) return;

    let data = modalData;
    if(option) {
        data = {...modalData, ...option};
    }

    let alertModalHtml = alertModalTmpl(data);
    $('body').append(alertModalHtml);

    if(typeof (buttonFunction) === 'function') {
        $('body').off('click', '#modalBtn00')
            .one('click', '#modalBtn00', buttonFunction);
    }
}

// legacy - close the modal and remove the backdrop class
function closeAlertModal() {
    $('#alertModalBackdrop').remove();
    $('#alertModal').remove();
}

/**********************************************************
    modalData: {
        title: 'Title',
        content: '<p>Content of the alert</p>',
        buttonText: 'OK'
    }
**********************************************************/
export function showModal(modalData, buttonFunction, option) {
    // if there is no data, don't do anything
    if(!modalData) return;

    let data = modalData;
    if(option) {
        data = {...modalData, ...option};
    }

    $(`#${MODAL_ID}`).empty().remove();
    let modalHtml = modalTmpl(data);
    $('body').append(modalHtml);
    let modal = document.getElementById(MODAL_ID);
    // eslint-disable-next-line no-undef
    dialogPolyfill.registerDialog(modal);
    modal.showModal();

    if(typeof (buttonFunction) === 'function') {
        $('body').off('click', BUTTON_ID)
            .on('click', BUTTON_ID, buttonFunction)
            .on('click', BUTTON_ID, closeModal);
    }
}

/**********************************************************
    modalData: {
        title: 'Title',
        content: '<p>Content of the alert</p>',
        buttonText: 'OK'
    }
**********************************************************/
export function showConfirmModal(modalData, buttonFunction, option) {
    // if there is no data, don't do anything
    if(!modalData) return;

    let data = modalData;
    let showModal = MODAL_CONFIRM_ID;
    if(option) {
        data = {...modalData, ...option};
    }
    let modalConfirmHtml = modalConfirmTmpl(data);

    $(`#${showModal}`).empty().remove();
    $('body').append(modalConfirmHtml);
    let modal = document.getElementById(showModal);
    // eslint-disable-next-line no-undef
    dialogPolyfill.registerDialog(modal);
    modal.showModal();

    if(typeof (buttonFunction) === 'function') {
        $('body').off('click', BUTTON_ID)
            .on('click', BUTTON_ID, buttonFunction);
    }
}

export function showError(response, data, buttonFunction) {
    let error = response.MessageModalError
        ? ERRORTYPE.ERROR
        : ERRORTYPE.WARN;

    showModal({...data,
        ...{
            errorType: error
        }}, buttonFunction);
}

export function closeModalById(modalId) {
    document.getElementById(modalId).close();
}

function closeModal() {
    closeModalById(MODAL_ID);
}

$(function() {
    $('body').on('click', '#closeModal, #modalBtn00', closeAlertModal);
});
